import '../../style/index.less';
import './index.less';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@3.9.2@antd/es/alert/style/index.js
// module id = ZA26
// module chunks = 0 9 10 19 23 24 25 26 32 33 49